module.exports = __webpack_public_path__ + "img/Screenshot_configure_settings.5e2b1218.png";